<template>
<div class="flex-table--row form-submission-card-content-select">
    <div
        v-for="(option, index) in answer.question.options"
        :key="option.id"
        :class="`form-submission-card-options col font-weight-bold btn-cursor-none btn ${answerClasses(answer, option)}`"
    >
        {{ option.label }}
    </div>
</div>
</template>

<script>
export default {
    props: [
        'answer',
    ],
    methods: {
        answerClasses(answer, option) {
            let classes = 'btn-secondary';
            if (this.type.includes('checkbox')) {
                answer.answer_options.some((answer_option) => {
                    if (answer_option?.option?.label === option.label) {
                        classes = this.getEffectClass(answer_option);
                        return true;
                    }
                });
            }

            if (this.type.includes('dropdown') && answer?.option?.label === option.label) {
                classes = this.getEffectClass(answer);
            }

            return classes;
        },
        getEffectClass(answer) {
            return answer.option.effect === 'fail' ? 'btn-negative' : 'btn-positive'
        },
    },
    computed: {
        type() {
            return this.answer.question.type;
        }
    }
}
</script>
